export const sendToMessageWhatsApp = (numberPhone?: string, message?: string) => {
  const baseWhatsappUrl = 'https://api.whatsapp.com/send';
  if (numberPhone && message) {
    return `${baseWhatsappUrl}?phone=553498121600&text=${message}`;
  } else if (numberPhone && !message) {
    return `${baseWhatsappUrl}?phone=553498121600`;
  } else if (!numberPhone && message) {
    return `${baseWhatsappUrl}?text=${message}`;
  }
  return `${baseWhatsappUrl}`;
};
